import React from 'react';
import { Link } from 'react-router-dom';
import { homeServices, autoServices, businessServices } from '../data/services';

const Footer = () => {
  const logoUrl = "/images/logo-eco-vapor-pro-120.webp";

  // Servizi privati = casa + auto (auto in cima per evidenza)
  const vehicleServices = autoServices.map((s) => ({
    path: s.path,
    label: s.title === 'Auto Detailing a Vapore' ? 'Auto Detailing' : s.title,
  }));
  const services = homeServices.map((s) => ({
    path: s.path,
    label: s.title === 'Finestre & Tapparelle' ? 'Finestre e Tapparelle' : s.title,
  }));
  const linkCls = 'text-gray-400 hover:text-green-400 transition-colors text-sm inline-block py-2';

  // Servizi B2B
  const businessServicesFooter = businessServices.map((s) => ({
    path: s.path,
    label: s.title === 'Flotte Auto e Furgoni' ? 'Flotte Auto e Furgoni' : s.title,
  }));

  const company = [
    { path: '/chi-siamo', label: 'Chi Siamo' },
    { path: '/come-funziona', label: 'Come Funziona' },
    { path: '/tecnologia-fortador-vapore-lamborghini', label: 'La Nostra Tecnologia' },
    { path: '/blog', label: 'Blog' },
    { path: '/contatti', label: 'Contatti' },
    { path: '/crm/login', label: 'Area Riservata' },
  ];

  return (
    <footer 
      className="bg-gray-900 text-white py-12 md:py-16"
      role="contentinfo"
      aria-label="Footer del sito"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Logo e Info */}
          <div className="col-span-2 md:col-span-3 lg:col-span-6">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={logoUrl} 
                alt="Eco Vapor Pro logo"
                aria-hidden="true"
                className="w-12 h-12 object-contain"
                loading="lazy"
                width="48"
                height="48"
              />
              <div>
                <p className="text-lg font-bold">Eco Vapor Pro</p>
                <p className="text-xs text-gray-400">Pulizia a vapore ovunque</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Servizi professionali di pulizia a vapore a domicilio a Bologna e provincia.
            </p>
            
            {/* Social Links */}
            <nav aria-label="Link ai social media">
              <ul className="flex space-x-2">
                <li>
                  <a 
                    href="https://www.instagram.com/ecovaporpro" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-green-500 transition-colors p-2 inline-block rounded-lg focus:ring-2 focus:ring-green-500" 
                    aria-label="Seguici su Instagram (si apre in una nuova finestra)"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z"/>
                      <circle cx="12" cy="12" r="3.5"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a 
                    href="https://www.facebook.com/ecovaporpro" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-green-500 transition-colors p-2 inline-block rounded-lg focus:ring-2 focus:ring-green-500" 
                    aria-label="Seguici su Facebook (si apre in una nuova finestra)"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a 
                    href="https://wa.me/393928901442" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-green-500 transition-colors p-2 inline-block rounded-lg focus:ring-2 focus:ring-green-500" 
                    aria-label="Contattaci su WhatsApp (si apre in una nuova finestra)"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.89 3.488"/>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          
          {/* Servizi Privati */}
          <nav aria-label="Servizi per la casa">
            <h2 className="text-sm font-semibold mb-4 text-white">Servizi Casa</h2>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link 
                    to={service.path} 
                    className="text-gray-400 hover:text-green-400 transition-colors text-sm inline-block py-2"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Servizi Veicoli */}
          <nav aria-label="Servizi per veicoli" data-testid="footer-veicoli">
            <h2 className="text-sm font-semibold mb-4 text-white">Servizi Veicoli</h2>
            <ul className="space-y-2">
              {vehicleServices.map((s) => <li key={s.path}><Link to={s.path} className={linkCls}>{s.label}</Link></li>)}
            </ul>
          </nav>

          {/* Servizi Business */}
          <nav aria-label="Servizi per aziende">
            <h2 className="text-sm font-semibold mb-4 text-white">Servizi Business</h2>
            <ul className="space-y-2">
              {businessServicesFooter.map((service) => (
                <li key={service.path}>
                  <Link 
                    to={service.path} 
                    className="text-gray-400 hover:text-green-400 transition-colors text-sm inline-block py-2"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* Azienda */}
          <nav aria-label="Informazioni aziendali">
            <h2 className="text-sm font-semibold mb-4 text-white">Azienda</h2>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className="text-gray-400 hover:text-green-400 transition-colors text-sm inline-block py-2"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Vendita / Concessionario (separata dai servizi) */}
          <nav aria-label="Vendita macchinari" data-testid="footer-vendita">
            <h2 className="text-sm font-semibold mb-4 text-orange-400">Vendita / Concessionario</h2>
            <ul className="space-y-2">
              {[
                { path: '/vendita-macchinari-fortador-voltab', label: 'Concessionario Fortador & Voltab' },
                { path: '/vendita-fortador-powered-by-lamborghini', label: 'Macchine a vapore Fortador' },
                { path: '/generatori-voltab', label: 'Generatori Voltab GO' },
              ].map((s) => <li key={s.path}><Link to={s.path} className="text-gray-400 hover:text-orange-400 transition-colors text-sm inline-block py-2">{s.label}</Link></li>)}
            </ul>
          </nav>

          {/* Contatti */}
          <div>
            <h2 className="text-sm font-semibold mb-4 text-white">Contatti</h2>
            <address className="not-italic">
              <ul className="space-y-3 text-sm text-gray-400">
                <li>
                  <a 
                    href="tel:+393928901442" 
                    className="hover:text-green-400 transition-colors flex items-center gap-2 py-1"
                    aria-label="Chiamaci al +39 392 890 1442"
                  >
                    <span aria-hidden="true">📞</span> 
                    <span>+39 392 890 1442</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="mailto:info@ecovaporpro.com" 
                    className="hover:text-green-400 transition-colors flex items-center gap-2 py-1"
                    aria-label="Scrivici a info@ecovaporpro.com"
                  >
                    <span aria-hidden="true">📧</span> 
                    <span>info@ecovaporpro.com</span>
                  </a>
                </li>
                <li className="flex items-center gap-2 py-1">
                  <span aria-hidden="true">📍</span> 
                  <span>Bologna · Ferrara · Modena · Imola · Ravenna</span>
                </li>
              </ul>
            </address>
          </div>
        </div>
        
        {/* Bottom section with legal links */}
        <div className="border-t border-gray-700 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © <time dateTime="2025">2025</time> Eco Vapor Pro. Tutti i diritti riservati. | P.IVA: 04359631209
            </p>
            <nav aria-label="Link legali">
              <ul className="flex items-center gap-6">
                <li>
                  <Link 
                    to="/privacy" 
                    className="text-gray-400 hover:text-green-400 transition-colors text-sm py-2 inline-block"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/cookie-policy" 
                    className="text-gray-400 hover:text-green-400 transition-colors text-sm py-2 inline-block"
                  >
                    Cookie Policy
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
